import { cn } from '@/shared/cn';

type Props = {
  logoUrl?: string;
  invertInDark?: boolean;
  name: string;
  size?: number;
  className?: string;
  variant?: 'card' | 'bare';
};

function hashToHue(input: string): number {
  let h = 0;
  for (let i = 0; i < input.length; i++) {
    h = (h * 31 + input.charCodeAt(i)) >>> 0;
  }
  return h % 360;
}

export function MarketplaceIcon({
  logoUrl,
  invertInDark,
  name,
  size = 32,
  className,
  variant = 'card',
}: Props) {
  if (logoUrl) {
    if (variant === 'bare') {
      return (
        <img
          src={logoUrl}
          alt=""
          aria-hidden="true"
          width={size}
          height={size}
          className={cn(
            'object-contain',
            invertInDark ? 'dark:invert' : undefined,
            className,
          )}
          style={{ width: size, height: size }}
          loading="lazy"
        />
      );
    }
    return (
      <span
        className={cn(
          'flex flex-shrink-0 items-center justify-center overflow-hidden rounded-lg bg-zinc-100 dark:bg-zinc-800',
          className,
        )}
        style={{ width: size, height: size }}
      >
        <img
          src={logoUrl}
          alt=""
          aria-hidden="true"
          width={Math.round(size * 0.6)}
          height={Math.round(size * 0.6)}
          className={cn(
            'object-contain',
            invertInDark ? 'dark:invert' : undefined,
          )}
          loading="lazy"
        />
      </span>
    );
  }

  const initial = name.trim().charAt(0).toUpperCase() || '?';
  const hue = hashToHue(name);
  return (
    <span
      className={cn(
        'flex flex-shrink-0 items-center justify-center rounded-lg font-semibold text-white',
        className,
      )}
      style={{
        width: size,
        height: size,
        backgroundColor: `hsl(${hue}deg 50% 45%)`,
        fontSize: Math.round(size * 0.45),
      }}
      aria-hidden="true"
    >
      {initial}
    </span>
  );
}
